import {
  CheckCircleIcon,
  MinusCircleIcon,
  XCircleIcon,
  ClockIcon,
} from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { itemIsNotApplicable, itemOutcomeKey } from "./checklistResponseConfig";

const OUTCOME_UI = {
  approved: {
    color: "bg-green-100 text-green-800",
    Icon: CheckCircleIcon,
    mark: "✅",
  },
  performed: {
    color: "bg-green-100 text-green-800",
    Icon: CheckCircleIcon,
    mark: "✅",
  },
  deviation: {
    color: "bg-red-100 text-red-800",
    Icon: XCircleIcon,
    mark: "❌",
  },
  na: {
    color: "bg-slate-100 text-slate-700",
    Icon: MinusCircleIcon,
    mark: "—",
  },
  pending: {
    color: "bg-gray-100 text-gray-700",
    Icon: ClockIcon,
    mark: "○",
  },
};

export function checklistOutcomeUi(item) {
  const key = itemOutcomeKey(item);
  return { key, ...OUTCOME_UI[key] };
}

/** Compact emoji/mark for legacy summary cards — never a red X unless avvik. */
export function ChecklistOutcomeGlyph({ item }) {
  return <span>{checklistOutcomeUi(item).mark}</span>;
}

export function ChecklistOutcomeBadge({ item }) {
  const { t } = useTranslation();
  const { key, color, Icon } = checklistOutcomeUi(item);
  return (
    <div
      className={clsx(
        "inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium",
        color
      )}
    >
      <Icon className="h-3 w-3" />
      {t(`quality.checklist.actions.${key === "pending" ? "pending" : key}`)}
    </div>
  );
}

export function checklistItemTitleClassName(item, base = "") {
  return clsx(
    base,
    itemIsNotApplicable(item) && "text-slate-500 line-through decoration-slate-400"
  );
}
